import feather from 'feather-icons/dist/feather';

var clusterColor = {
  /**
   * Setting colours for header, nav, footer
   * @param {*} element 
   * @param {*} opacity 0 - 100
   * var elemt = document.getElementsByClassName('banner');
  */
  changeElementBgColor: function (element, opacity) {
    var elementObj = element[0]
    if ('color' in elementObj.dataset) {
      var colorToChange = elementObj.dataset.color
      elementObj.style.backgroundColor = clusterColor.convertHex(colorToChange, opacity);
    }
  },
  /**
   * ECMA2015
   */
  convertHex: function (hexCode, opacity) {
    var hex = hexCode.replace('#', '');

    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    var r = parseInt(hex.substring(0, 2), 16),
      g = parseInt(hex.substring(2, 4), 16),
      b = parseInt(hex.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  },
};

export default {
  init() {
    // JavaScript to be fired on all pages

    // Change color of the header
    var mainHeader = document.getElementsByClassName('banner');
    var pageHeader = document.getElementsByClassName('header-overlay');

    if (mainHeader != null) {
      clusterColor.changeElementBgColor(mainHeader, 0);
    }
    if (pageHeader != null) {
      clusterColor.changeElementBgColor(pageHeader, 80);
    }


    /** overlay color on pill images */
    Array.from(document.getElementsByClassName('pill-image')).forEach(function (pill) {
      clusterColor.changeElementBgColor(pill.getElementsByClassName('card-img-overlay'), 80);
    });

    /** Nav Menu */
    $('.navbar-toggler').click(function () {
      if ($(this).hasClass('collapsed')) {
        $(this).removeClass('collapsed');
        $('header.banner .nav-primary').addClass('active');
      } else {
        $(this).addClass('collapsed');
        $('header.banner .nav-primary').removeClass('active');
      }
    });

    $('#menu-primary-navigation a').click(function () {
      if ($('.navbar-toggler').hasClass('collapsed')) {
        $('.navbar-toggler').removeClass('collapsed');
        $('header.banner .nav-primary').addClass('active');
      } else {
        $('.navbar-toggler').addClass('collapsed');
        $('header.banner .nav-primary').removeClass('active');
      }
    });

    /**
     *  Sets cookie to keep popup closed
     */
    function setCookie() {
      let now = new Date();
      let expiryDate = now.setMonth(now.getTime() + 24 * 60 * 60 * 1000);
      now.setTime(expiryDate);
      document.cookie = 'sitealert=true;expires=' + now.toGMTString() + ';path=/';
    }

    $('.site-alert .close').click(function (e) {
      e.preventDefault();
      setCookie();
      $('.site-alert').slideUp('fast', function () {
        var mastHeadHeight = $('#masthead').css('height');
        $('.header-overlay').css('padding-top', mastHeadHeight);
      });
    });

    // Checks if alert is enabled and cookie is not set
    if (document.cookie.indexOf('sitealert') != -1) {
      $('.site-alert').remove();
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    feather.replace();

    // Set padding on bdy for fixed header
    $(window).on('load', function () {
      var bodyHeight = $('body').css('height');
      var mastHeadHeight = $('#masthead').css('height');
      $('.header-overlay').css('padding-top', mastHeadHeight);
      $('.body-circle-wrap').css('height', bodyHeight);
      $(window).resize(function () {
        var bodyHeight = $('body').css('height');
        var mastHeadHeight = $('#masthead').css('height');
        $('.header-overlay').css('padding-top', mastHeadHeight);
        $('.body-circle-wrap').css('height', bodyHeight);
      });
    });

    // When the user scrolls the page, execute myFunction 
    window.addEventListener('scroll', function () {
      if (window.scrollY >= 1) {
        headerMetaAnimationScrolled();
      } else {
        headerMetaAnimationTop();
      }

      /** Header circle scrolling */
      $('.large-circle').css({
        'margin-top': -$(window).scrollTop() / 1.5 + 'px',
      });

      $('.small-circle').css({
        'margin-top': $(window).scrollTop() / 1.5 + 'px',
      });

      /** Body circle scrolling */
      $('.body-circle.top').css({
        'margin-top': $(window).scrollTop() / 5 + 'px',
      });

      $('.body-circle.middle').css({
        'margin-top': -$(window).scrollTop() / 8 + 'px',
        'margin-left': -$(window).scrollTop() / 6 + 'px',
      });

      $('.body-circle.bottom').css({
        'margin-top': -$(window).scrollTop() / 1.4 + 'px',
      });

    });

    var mainHeader = document.getElementsByClassName('banner');

    /**
     * Change the header-meta on the main nav
     */
    function headerMetaAnimationScrolled() {
      $('#masthead').addClass('minimize');
      clusterColor.changeElementBgColor(mainHeader, 95);
    }
    /**
     * Change the header-meta on the main nav
     */
    function headerMetaAnimationTop() {
      $('#masthead').removeClass('minimize');
      clusterColor.changeElementBgColor(mainHeader, 0);
    }
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js